import { useEffect } from 'react';

const GoogleAnalytics = ({ trackingId = 'G-442M4N4GWV' }) => {
  useEffect(() => {
    // Check if gtag script is already loaded
    if (window.gtag) {
      return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    
    // Define gtag function
    function gtag() {
      window.dataLayer.push(arguments);
    }
    
    // Make gtag available globally
    window.gtag = gtag;
    
    // Initialize gtag
    gtag('js', new Date());
    gtag('config', trackingId, {
      // Set custom parameter for language tracking
      custom_map: {
        'custom_language': 'current_language'
      }
    });

    // Create and load the gtag script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    
    script.onload = () => {
      // Set initial language parameter
      if (window.current_language) {
        gtag('config', trackingId, {
          'current_language': window.current_language
        });
      }
    };
    
    script.onerror = () => {
      console.error('Failed to load Google Analytics');
    };

    // Append script to head
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      // Remove script on component unmount
      const existingScript = document.querySelector(`script[src*="${trackingId}"]`);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [trackingId]);

  // This component doesn't render anything visible
  return null;
};

export default GoogleAnalytics;